module.exports = __webpack_public_path__ + "static/img/report_icon3.6505bb9e.png";